import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import Form from "react-bootstrap/Form";
import * as NumericInput from "react-numeric-input";
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import CustomSelect from '../../components/custom-select/CustomSelect';
import AlertDialog from '../../components/alert-dialog/AlertDialog';

import * as RestService from '../../services/eisRest';
import countryList from './country.json';




  const PartnerModal = (props) => {

   
    const [selectedRecord, setSelectedRecord] =  useState();  
    const [t] = useTranslation();         
    const [data, setData] = useState();
    const [partner, setPartner] = useState();    
    const [vatPayer, setVatPayer] = useState();
    const [countryIso, setCountryIso] = useState();
    const [initialData,setInitialData] = useState();
    const [credit,setCredit]= useState(true);
    const [creditValue,setCreditValue]= useState();
    const [paymentDue,setPaymentDue]= useState();
    const [discount,setDiscount]= useState();
    
    
    const yesNoOptions = [
      { value: 1, label:  t('general.label.yes')},
      { value: 0, label:  t('general.label.no')}                  
    ];
     
    const countryOptions = countryList;
  
    
    const hideModal = () => {
      props.parentCallback();
    };
    
    const changeCredit = () =>{
        setCredit(!credit);       
    }


    const percentFormat = (num) => {
        return num + '%';
    }

    const numberFormat = (num) => {
        return  parseFloat(num.replace(",", "."));
    }
    
    const handleNumericChange =(k,value)=>{
     
       // console.log(value);
        switch(k){
            case "creditValue":
                setCreditValue(value);
            break;
            case "paymentDue":
                setPaymentDue(value);
            break;
            case "discount":
                setDiscount(value);
            break;
        }
    }

    const apiOrder = (call) => {
        switch(call){       
          case "getPartner":
            RestService.callAnyApi('partner/getPartner?id='+props.selectedRecord, null)
            .then((data) => {
                 setPartner(data);
                 props.loadedPartner(data);
                 const dataTemp = {
                    name: data.address.name,                       
                    firstName: data.address.firstName,
                    lastName: data.address.lastName,                                                                            
                    street: data.address.street,
                  //  houseNumber: data.address.houseNumber,
                    city: data.address.city,
                    postalCode: data.address.postalCode,
                    businessId: data.address.businessId,
                    taxId: data.address.taxId,
                    vatNo: data.address.vatNo,
                    phone: data.address.phone,                    
                    mobilePhone: data.address.mobilePhone,      
                    officeEmail: data.address.officeEmail,      
                    description: data.address.description   
                                      

                 };
                
                 setVatPayer(data.address.vatPayer);
                 setCountryIso(data.address.countryIso);
                 setCredit(data.address.credit);
                 setCreditValue(data.address.creditValue);
                 setPaymentDue(data.address.paymentDue);
                 setDiscount(data.address.discount);
                 setInitialData(dataTemp);
                 
               
            })
            .catch((error) => {    
              toast.error(error);
            });
          break;          
        }

    }
   

   
    useEffect(() => {      
      
      setSelectedRecord(props.selectedRecord);
      apiOrder("getPartner");

    }, [props.selectedRecord])

  
   
    
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

    const save = (url,values) => {
       
       if(countryIso==null || countryIso=='') {
        showError(null,t('general.message.countryIsRequired'));
        return;
       }


      try{
        partner.address.name = values.name;       
        partner.address.firstName = values.firstName;        
        partner.address.lastName = values.lastName;                
        partner.address.street = values.street;
       // partner.address.houseNumber = values.houseNumber;
        partner.address.city = values.city;
        partner.address.postalCode = values.postalCode;

        partner.address.businessId = values.businessId;
        partner.address.taxId = values.taxId;
        partner.address.vatNo = values.vatNo;

        partner.address.phone = values.phone;
        partner.address.mobilePhone = values.mobilePhone;
        partner.address.officeEmail = values.officeEmail;       
        partner.address.description = values.description;   
        partner.address.creditValue = creditValue;
        partner.address.paymentDue = paymentDue;
        partner.address.discount = discount;
       
    
        partner.address.credit = (credit ? 1 : 0);
        partner.address.vatPayer = vatPayer;
        partner.address.countryIso = countryIso;
        partner.partnerType = props.partnerType;  
        
      }catch(error){
        console.log(error);
      }

      RestService.callAnyApi(url,partner)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                          toast.success(t('general.message.saveSucceed'));    
                          setSelectedRecord(data.responseObject.id);
                          props.loadedPartner(data.responseObject);
                      }else{
                          showError(null,data.responseMessage);
                      }
                  
                 
          })
          .catch((error) => {               
            showError(error,null);
          });
    };

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: initialData,
      validationSchema: Yup.object({
        name: Yup.string()   
          .nullable()  
          .test(
            'oneOfRequired',
            t('general.message.oneOfRequired'),
            function(item) {
              return (this.parent.name || (this.parent.firstName && this.parent.lastName))
            }
          ),         
        firstName: Yup.string()   
          .nullable()  
          .test(
            'oneOfRequired',
            t('general.message.oneOfRequired'),
            function(item) {
              return (this.parent.name || (this.parent.firstName && this.parent.lastName))
            }
          ),
        lastName: Yup.string()     
          .nullable()  
          .test(
            'oneOfRequired',
            t('general.message.oneOfRequired'),
            function(item) {
              return (this.parent.name || (this.parent.firstName && this.parent.lastName))
            }
          ),  
        //  countryIso:  Yup.string()     
        //  .required(t('general.message.required')),
       //  nbr: Yup.string()     
       //   .required(t('general.message.required'))
          
      
       
        officeEmail: Yup.string()
          .nullable()  
          .email(),
      }),
      onSubmit: (values) => {           
          save('partner/savePartner',values);         
      }
      
    });


    return (
      <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
      <form onSubmit={formik.handleSubmit}>  



                    <div className="row">

                          <div className="col-4 col-sm-4 col-lg-4">
                              <div className="form-group">
                                  <label>{t('general.label.name')}</label>
                                  <input type="text" className="form-control"  {...formik.getFieldProps('name')} placeholder={t('general.label.name')} />
                                  {formik.touched.name && formik.errors.name ? (<div style={{ color: 'red' }}>{formik.errors.name}</div>) : null} 
                              </div>
                          </div>

                          <div className="col-4 col-sm-4 col-lg-4">
                              <div className="form-group">
                                  <label>{t('user.label.firstName')}</label>
                                  <input type="text" className="form-control"  {...formik.getFieldProps('firstName')} placeholder={t('user.label.firstName')} />
                                  {formik.touched.firstName && formik.errors.firstName? (<div style={{ color: 'red' }}>{formik.errors.firstName}</div>) : null} 
                              </div>
                          </div>

                          <div className="col-4 col-sm-4 col-lg-4">
                              <div className="form-group">
                                    <label>{t('user.label.lastName')}</label>
                                    <input type="text" className="form-control"  {...formik.getFieldProps('lastName')} placeholder={t('user.label.lastName')} />
                                    {formik.touched.lastName && formik.errors.lastName? (<div style={{ color: 'red' }}>{formik.errors.lastName}</div>) : null} 
                              </div>
                          </div>  

                    </div>
    

                    <div className="row">

                        <div className="col-8  col-sm-8 col-lg-8">
                            <div className="form-group">
                                <label>{t('general.label.street')}</label>
                                <input type="text" className="form-control"  {...formik.getFieldProps('street')} placeholder={t('general.label.street')} />
                                {formik.touched.street && formik.errors.street ? (<div style={{ color: 'red' }}>{formik.errors.street}</div>) : null} 
                            </div>
                        </div>
                       

                        <div className="col-4">
                            <div className="form-group">
                                <label>{t('general.label.postalCode')}</label>
                                <input type="text" className="form-control"  {...formik.getFieldProps('postalCode')} placeholder={t('general.label.postalCode')} />
                                {formik.touched.postalCode && formik.errors.postalCode ? (<div style={{ color: 'red' }}>{formik.errors.postalCode}</div>) : null} 
                            </div>
                        </div>

                    </div>

                    <div className="row">

                          <div className="col-8  col-sm-8 col-lg-8">
                              <div className="form-group">
                                  <label>{t('general.label.city')}</label>
                                  <input type="text" className="form-control"  {...formik.getFieldProps('city')} placeholder={t('general.label.city')} />
                                  {formik.touched.city && formik.errors.city ? (<div style={{ color: 'red' }}>{formik.errors.city}</div>) : null} 
                              </div>
                          </div>
                        
                          <div className="col-4">
                              <div class="form-group">
                                  <label>{t('general.label.country')}</label>                               
                                  <CustomSelect 
                                    className='input'
                                    name="countryIso"                                         
                                    onChange={(opt, e) => {                                             
                                        setCountryIso(opt.value);
                                        formik.setFieldValue('countryIso', opt.value);
                                    }}
                                    value={countryIso}
                                    options={countryOptions}     
                                  />
                                 
                              </div>
                          </div>

                     </div>

                    

                    <div className="row">

                          <div className="col-3">
                              <div className="form-group">
                                  <label>{t('general.label.businessId')}</label>
                                  <input type="text" className="form-control"  {...formik.getFieldProps('businessId')} placeholder={t('general.label.businessId')} />
                                  {formik.touched.businessId && formik.errors.businessId ? (<div style={{ color: 'red' }}>{formik.errors.businessId}</div>) : null} 
                              </div>
                          </div>

                          <div className="col-3">
                              <div className="form-group">
                                  <label>{t('general.label.taxId')}</label>
                                  <input type="text" className="form-control"  {...formik.getFieldProps('taxId')} placeholder={t('general.label.taxId')} />
                                  {formik.touched.taxId && formik.errors.taxId ? (<div style={{ color: 'red' }}>{formik.errors.taxId}</div>) : null} 
                              </div>
                          </div>

                          <div className="col-3">
                              <div className="form-group">
                                  <label>{t('general.label.vatNo')}</label>
                                  <input type="text" className="form-control"  {...formik.getFieldProps('vatNo')} placeholder={t('general.label.vatNo')} />
                                  {formik.touched.vatNo && formik.errors.vatNo ? (<div style={{ color: 'red' }}>{formik.errors.vatNo}</div>) : null} 
                              </div>
                          </div>

                          <div className="col-3">
                              <div class="form-group">
                                <label>{t('general.label.vatPayer')}</label>
                                <CustomSelect
                                    className='input'
                                    name="vatPayer"                                         
                                    onChange={(opt, e) => {                                             
                                        setVatPayer(opt.value);
                                        formik.setFieldValue('vatPayer', opt.value);
                                    }}
                                    value={vatPayer}
                                    options={yesNoOptions}     
                                />
                                {formik.errors.vatPayer ? <div className='error'>{formik.errors.vatPayer}</div> : null}
                              </div>

                          </div>

                    </div>


                    <div className="row">

                          <div className="col-3  col-sm-3 col-lg-3">
                              <div className="form-group">
                                  <label>{t('user.label.phone')}</label>
                                  <input type="text" className="form-control"  {...formik.getFieldProps('phone')} placeholder={t('user.label.phone')} />
                                  {formik.touched.phone && formik.errors.phone ? (<div style={{ color: 'red' }}>{formik.errors.phone}</div>) : null} 
                              </div>
                          </div>

                          <div className="col-3 col-sm-3 col-lg-3">
                              <div className="form-group">
                                  <label>{t('user.label.mobilePhone')}</label>
                                  <input type="text" className="form-control"  {...formik.getFieldProps('mobilePhone')} placeholder={t('user.label.mobilePhone')} />
                                  {formik.touched.mobilePhone && formik.errors.mobilePhone ? (<div style={{ color: 'red' }}>{formik.errorsmobilePhone}</div>) : null} 
                              </div>
                          </div>

                          <div className="col-6 col-sm-6 col-lg-6">
                              <div className="form-group">
                                  <label>{t('user.label.officeEmail')}</label>
                                  <input type="text" className="form-control"  {...formik.getFieldProps('officeEmail')} placeholder={t('user.label.officeEmail')} />
                                  {formik.touched.officeEmail && formik.errors.officeEmail ? (<div style={{ color: 'red' }}>{formik.errors.officeEmail}</div>) : null} 
                              </div>
                          </div>

                    </div>


                    <div className="row">



                            <div className="col-6">
                                <div className="form-group">
                                    <label>{t('general.label.commercialRegister')}</label>
                                    <input type="text" className="form-control"  {...formik.getFieldProps('commercialRegister')} placeholder={t('general.label.commercialRegister')} />
                                    {formik.touched.commercialRegister && formik.errors.commercialRegister ? (<div style={{ color: 'red' }}>{formik.errors.commercialRegister}</div>) : null} 
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="form-group">
                                    <label>{t('general.label.description')}</label>
                                    <input type="text" className="form-control"  {...formik.getFieldProps('description')} placeholder={t('general.label.description')} />
                                    {formik.touched.description && formik.errors.description ? (<div style={{ color: 'red' }}>{formik.errors.description}</div>) : null} 
                                </div>
                            </div>

                    </div>           

                    <div className="row">                          

                            <div className="col-3 col-sm-3 col-lg-3">
                                <div className="form-group">
                                    <label>{t('partner.label.creditValue')}</label>
                                    <NumericInput  className="form-control" precision={0} value={creditValue} step={1} format={numberFormat} onChange={value => handleNumericChange('creditValue', value)}/>
                                   
                                </div>
                            </div>

                            <div className="col-3 col-sm-3 col-lg-3">
                                <div className="form-group">
                                    <label>{t('partner.label.paymentDue')}</label>
                                    <NumericInput className="form-control"  precision={0} value={paymentDue} step={1} format={numberFormat}  onChange={value => handleNumericChange('paymentDue', value)}  />
                                    
                                </div>
                            </div>

                            <div className="col-2 col-sm-2 col-lg-2">
                                <div className="form-group">
                                    <label>{t('partner.label.discount')}</label>
                                    <NumericInput className="form-control"  precision={2} value={discount} step={0.1} format={percentFormat}  onChange={value => handleNumericChange('discount', value)}/>
                                   
                                </div>
                            </div>


                            <div className="col-1  col-sm-1 col-lg-1">
                                <div className="form-group">  
                                        <label>{t('partner.label.credit')}</label>
                                        <Form.Check
                                            style={{"margin-left":"10px","margin-top": "4px","transform": "scale(1.5)", "-webkit-transform": "scale(1.5)"}}
                                            type='checkbox'                                           
                                            onChange={changeCredit}                                           
                                            checked={credit}
                                        />                                                                      
                                </div>
                            </div>

                    </div>

                        

                    <div className="card-footer">
                            <Button className="btn-primary" type="submit">{t('general.button.save')}</Button>     
                            <Button className="btn-default float-right" onClick={hideModal}>{t('general.button.cancel')}</Button>    
                                                    
	            	       			
                  			</div>
                        </form>

        </div>
    );
};

 export default PartnerModal;